import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/$owner/account/settings/password'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$owner/account/settings/sign-in',
      params: { owner: params.owner }
    });
  }
});
